import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    accessToken: null,
    guestUser: null,
    userEmail: null,
    tempToken: null,
    subscription: null,
    redirectUrl: null,
    onboarding: null,
  },

  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;

      if (action.payload.attributes && action.payload.attributes.length > 0) {
        for (let index = 0; index < action.payload.attributes.length; index++) {
          const attr = action.payload.attributes[index];
          if (attr.type === "email") {
            state.userEmail = attr.value;
          } else {
            state.userEmail = null;
          }
        }

        // action.payload.attributes.find((attr: any) => {
        //   if (attr.type === "email") {
        //     state.userEmail = attr.value;
        //   } else {
        //     state.userEmail = null;
        //   }
        // });
      }
    },

    setGuestUser: (state, action) => {
      state.guestUser = action.payload.guestUser;
    },

    setTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    setTempToken: (state, action) => {
      state.tempToken = action.payload.access_token;
    },

    setSubscription: (state, action) => {
      state.subscription = action.payload;
    },

    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
    setOnboarding: (state, action) => {
      state.onboarding = action.payload;
    },

    clearAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.userEmail = null;
      state.subscription = null;
      state.redirectUrl = null;
      state.onboarding = null;
    },

    clearGuestUser: (state) => {
      state.guestUser = null;
    },

    clearTempToken: (state) => {
      state.tempToken = null;
    },
  },
});

export const {
  setUser,
  setGuestUser,
  setTokens,
  setTempToken,
  setSubscription,
  setRedirectUrl,
  clearAuth,
  setOnboarding,
  clearGuestUser,
  clearTempToken,
} = authSlice.actions;

export default authSlice.reducer;
